import { Card } from "@/components/ui/card";
import { Cake, PartyPopper, ArrowRight } from "lucide-react";

export default function BirthdayCard({ birthdays, onNavigate }) {
  return (
    <Card className="p-6 border-slate-200 shadow-none rounded-lg" data-testid="birthday-card">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => onNavigate?.("pekerja")} data-testid="goto-pekerja-birthday"
          className="flex items-center gap-2 group" title="Buka Data Pekerja">
          <Cake className="h-4 w-4 text-rose-500" />
          <h3 className="text-base font-semibold text-slate-900 group-hover:text-rose-600 transition-colors">Ulang Tahun Bulan Ini</h3>
          <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-rose-600 group-hover:translate-x-0.5 transition-all" />
        </button>
        <span className="text-xs text-slate-400 ml-auto">
          {new Date().toLocaleDateString("id-ID", { month: "long", year: "numeric" })}
        </span>
      </div>
      {birthdays?.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="birthday-list">
          {birthdays.map((b, i) => (
            <div key={`${b.nomor_pegawai || b.nama}-${b.hari}`} data-testid={`birthday-item-${i}`}
              className={`rounded-lg border p-3 flex items-center gap-3 ${
                b.hari_ini ? "border-rose-200 bg-rose-50" : "border-slate-100 bg-slate-50/60"
              }`}>
              <div className={`h-10 w-10 rounded-lg flex flex-col items-center justify-center shrink-0 ${
                b.hari_ini ? "bg-rose-500 text-white" : "bg-white border border-slate-200 text-slate-700"
              }`}>
                <span className="text-sm font-bold leading-none">{b.hari}</span>
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-slate-900 truncate">{b.nama}</p>
                <p className="text-xs text-slate-500 truncate">
                  {b.jabatan}{b.lokasi_kerja ? ` · ${b.lokasi_kerja}` : ""} · ke-{b.usia_baru}
                </p>
              </div>
              {b.hari_ini && (
                <span className="flex items-center gap-1 text-[11px] font-bold text-rose-600 shrink-0">
                  <PartyPopper className="h-3.5 w-3.5" /> Hari Ini
                </span>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-slate-400" data-testid="birthday-empty">
          Tidak ada pekerja yang berulang tahun bulan ini.
        </p>
      )}
    </Card>
  );
}
